// extracted by css-extract-rspack-plugin
export default {"footer":"ModelPicker-module__footer__L4qZk"};